import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Category} from "../../models/category";

import { locale as polish } from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector     : 'category-form-dialog',
    templateUrl  : './categoryDialog.component.html',
    styleUrls    : ['./categoryDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CategoryDialogComponent
{
    action: string;
    categories: any[];
    category: Category;
    categoryForm: FormGroup;
    dialogTitle: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<CategoryDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<CategoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService
    )
    {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.categories = _data.categories;

        if ( this.action === 'edit' )
        {
            translate.get('Edit Category').subscribe((text:string) => {this.dialogTitle = text});

            this.category = _data.category;
        }
        else
        {
            translate.get('New category').subscribe((text:string) => {this.dialogTitle = text});
            this.category = new Category();
        }

        this.categoryForm = this.createCategoryForm();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create contact form
     *
     * @returns {FormGroup}
     */
    createCategoryForm(): FormGroup
    {
        return this._formBuilder.group({
            id      : [this.category.id],
            name    : [this.category.name],
            parent  : [this.category.parent],
            type    : [this.category.type],
        });
    }
}
